module.exports = __webpack_public_path__ + "img/cuff length.1e29f9f7.png";